export class Relay {
    constructor(scene) {
        this.scene = scene;
    }
    
   get methods() {
        return {
            purchase: () => {
                this.scene.request.purchase(true);
            },
            showChosenPaylines: () => {
                this.scene.payline.showChosenPaylines();
            },
            setAutoSpin: () => {
                this.scene.request.setAutoSpin();
            },
            toggleSpeed: (value) => {
                this.scene.slots.toggleSpeed(value);
            },
            toggleMute: (value) => {
                this.scene.toggleMute(value);
            },
            setExplanationStatus: (value) => {
                this.scene.request.setExplanationStatus(value);
            },
            clickEvent: (value) => {
                this.scene.clickEvent(value);
            },
        };
    }
}